import React from "react";

const Iframe = ({ source, small }) => {
  const divStyle = {
    zIndex: 100000,
    position: "relative",
    border: "none",
    height: "640px",
    width: "500px",
    opacity: 1
  };
  if (small) {
    divStyle["width"] = "120px";
  }

  const src = source;
  return (
    // basic bootstrap classes. you can change with yours.
    <div className="col-md-12">
      <div className="emdeb-responsive">
        <iframe src={src} style={divStyle}></iframe>
      </div>
    </div>
  );
};

export default Iframe;
